import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../setupapp/setup.css'; // Use V2 styles

const OnePurchase = (props) => {
    const displayName = ' ' + props.name.charAt(0).toUpperCase() + props.name.slice(1);
    const urlName = props.name.charAt(0).toUpperCase() + props.name.slice(1);

    const date = new Date(props.time);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const navigate = useNavigate();
    const formattedDate = date.toLocaleString('en-US', options);

    const goToDownloads = () => navigate('/thanksforpurchase/' + urlName)

    return (
        <motion.div 
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            className="setup-plugin-card" 
            style={{ padding: '24px 32px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
            <div>
                <div className="setup-plugin-name" style={{ fontSize: '20px', marginBottom: '4px' }}>
                    {displayName.trim()}
                </div>
                <div className="setup-step-desc">
                    Purchased on {formattedDate}
                </div>
            </div>

            <button 
                className="setup-btn-secondary" 
                style={{ flex: '0 1 auto', padding: '12px 24px', fontSize: '14px', width: 'auto' }} 
                onClick={goToDownloads}
            >
                Downloads
            </button>
        </motion.div>
    );
};

export default OnePurchase;
